import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Payroll Expense Entry: A financial record documenting salary and benefit expenses for employees.',
    name: 'Payroll Expenses',
    partialId: PartialId.Standard.create('pay_exp'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
